import { reactive } from 'vue'
import { normalizeGridColumnProps } from './column/seq-column'
import type { GridColumnProps, GridOptions, GridQueryParams } from './types'

export type GridOptionConfig = Omit<
  GridOptions,
  'queryByExamplePage' | 'getCurrentRow' | 'getAllCheckbox' | 'currentRow'
> & {
  parent?: GridOption | GridOptions | Record<string, unknown>
}

export class GridOption {
  tableId?: string
  module!: string
  columns!: GridColumnProps[]
  parent?: GridOption | GridOptions | Record<string, unknown>
  queryByExamplePage!: (overrideParams?: GridQueryParams) => Promise<void>
  getCurrentRow!: () => Record<string, unknown> | null
  getAllCheckbox!: () => Record<string, unknown>[]

  constructor(config: GridOptionConfig) {
    if (!config.module) {
      throw new Error('[GridOption] module is required')
    }
    if (!config.columns?.length) {
      throw new Error('[GridOption] columns is required')
    }
    Object.assign(this, {
      ...config,
      columns: normalizeGridColumnProps(config.columns),
      getCurrentRow: () => null,
      getAllCheckbox: () => [],
      queryByExamplePage: async () => {},
    })
    return reactive(this) as this
  }

}

export type GridOptionConstructor = typeof GridOption

if (typeof globalThis !== 'undefined') {
  globalThis.GridOption = GridOption
}
